import cn from "classnames";
import { t } from "i18next";
import ClipLoader from "react-spinners/ClipLoader";

import { ButtonProps } from "./Button.types";

import styles from "./Button.module.scss";

const Button = ({
  children,
  loading = false,
  variant = "primary",
  size = "md",
  block = false,
  icon = null,
  rightIcon = null,
  disabled = false,
  title = "",
  onClick,
  className,
  ...props
}: ButtonProps) => {
  return (
    <button
      className={cn(
        styles.button,
        { [styles["button-block"]]: block },
        styles[`button-${size}`],
        styles[`button-${variant}`],
        className
      )}
      disabled={disabled || loading}
      onClick={onClick}
      type={"button"}
      {...props}
    >
      {loading ? (
        <ClipLoader size={15} color="#fff" />
      ) : (
        <>
          {icon} {children ?? t(title)} {rightIcon}
        </>
      )}
    </button>
  );
};

export default Button;
